import React from "react";

const Edit = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      width="12"
      height="12"
      viewBox="0 0 12 12"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.44339 8.44844C1.50072 8.46755 1.55282 8.49975 1.59556 8.54248L3.45752 10.4044C3.60955 10.5565 3.60955 10.803 3.45752 10.955C3.41478 10.9977 3.36268 11.0299 3.30535 11.049L0.512409 11.98C0.308437 12.048 0.0879683 11.9378 0.0199777 11.7338C-0.00665922 11.6539 -0.00665922 11.5675 0.0199777 11.4876L0.950957 8.69465C1.01895 8.49068 1.23942 8.38045 1.44339 8.44844ZM9.68376 0.114024L11.886 2.31624C12.038 2.46828 12.038 2.71477 11.886 2.8668L4.72876 10.024C4.57673 10.176 4.33024 10.176 4.1782 10.024L1.97598 7.8218C1.82395 7.66976 1.82395 7.42327 1.97598 7.27124L9.1332 0.114024C9.28523 -0.0380079 9.53172 -0.0380079 9.68376 0.114024Z"
      />
    </svg>
  );
};

export default Edit;
